import CryptoJS from "crypto-js";
import { keycloakConfig } from "../config/keycloakConfig";
import Fingerprint from "fingerprintjs";
import forge from "node-forge";
import { fetchPublicRsaKeyAPI, logoutApi } from "../api/SignupAPI";
import jwt_decode from "jwt-decode";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import parse from "html-react-parser";
import ENV from "../Environments";
import { Paths } from "../Routes/path";
import moment from "moment";

const airtelEDKey = "A!rt3lOnl!n33ncrypt30n5tr!ngHJS3cur!ty";

export const notEmptyArray = (obj) => {
  return obj instanceof Array && obj.length !== 0;
};

export const removeFromLocalStorage = (moduleId, key) => {
  const localStorageKey = `${moduleId + key}`;
  if (localStorage[localStorageKey]) {
    delete localStorage[localStorageKey];
  }
};

export const isLocalStorageSupported = () => {
  const testKey = "test";
  const storage = window.localStorage;
  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

export const getDecryptedString = (ciphertext) => {
  if (!ciphertext) return ciphertext;
  var keyHex = CryptoJS.enc.Utf8.parse(airtelEDKey);
  // direct decrypt ciphertext
  var decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(ciphertext),
    },
    keyHex,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  var message = decrypted.toString(CryptoJS.enc.Utf8);

  //if encryption source was object
  try {
    message = JSON.parse(message);
    return message;
  } catch (err) {
    //if encryption source was string
    return message;
  }
};

export const getFromLocalStorage = (moduleId, key) => {
  const localStorageKey = `${moduleId + key}`;
  if (!localStorage[localStorageKey]) {
    return null;
  }

  if (isLocalStorageSupported()) {
    return Object.assign(
      {},
      getDecryptedString(JSON.parse(localStorage[localStorageKey]))
    );
  }
};

export const getEncryptedString = (message) => {
  if (!message) return message;
  if (typeof message === "object") {
    message = JSON.stringify(message);
  } else {
    message = String(message);
  }
  var keyHex = CryptoJS.enc.Utf8.parse(airtelEDKey);
  var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const setInLocalStorage = (moduleId, key, obj) => {
  const localStorageKey = `${moduleId + key}`;
  if (isLocalStorageSupported()) {
    let cipherText = getEncryptedString(obj);
    cipherText = `"${cipherText}"`;
    localStorage[localStorageKey] = cipherText;
  }
};

export const getUserLoggedInDetails = () => {
  const loggedInDetails = getFromLocalStorage("lco", "login");
  return loggedInDetails;
};

export const getPartnerLoggedInDetails = () => {
  const loggedInDetails = getFromLocalStorage("team", "login");
  return loggedInDetails;
};

export const getVendorLoggedInDetails = () => {
  const loggedInDetails = getFromLocalStorage("vendor", "login");
  return loggedInDetails;
};

export const getScmLoggedInDetails = () => {
  const loggedInDetails = getFromLocalStorage("scm", "login");
  return loggedInDetails;
};

export const doLogout = async (status) => {
  !status && (await logoutApi());
  removeAllDataFromStorage();
  if (isPartner()) {
    window.location.replace(window.location.origin + ENV.getTeamsBasePath());
    return;
  } else if (isVendor()) {
    window.location.replace(
      window.location.origin + ENV.getVendorBasePath() + Paths.vendorLogin.path
    );
  } else if (isMarketPlace()) {
    window.location.replace(
      window.location.origin + ENV.getBaseName() + Paths.scmLogin.path
    );
  } else {
    window.location.replace(window.location.origin + ENV.getBaseName());
  }
};

export const getDecodedTokenData = () => {
  try {
    if (!getFromLocalStorage("lco", "login")) {
      return {};
    }
    const loggedInDetails = jwt_decode(
      getFromLocalStorage("lco", "login").accessToken
    );
    return loggedInDetails;
  } catch (e) {
    console.log(e, "error is");
  }
  const loggedInDetails = jwt_decode(
    getFromLocalStorage("lco", "login").accessToken
  );
  return loggedInDetails;
};

export const getPartnerDecodedTokenData = () => {
  try {
    if (!getFromLocalStorage("team", "login")) {
      return {};
    }
    const loggedInDetails = jwt_decode(
      getFromLocalStorage("team", "login").accessToken
    );
    return loggedInDetails;
  } catch (e) {
    console.log(e, "error is");
  }
};

export const getVendorDecodedTokenData = () => {
  try {
    if (!getFromLocalStorage("vendor", "login")) {
      return {};
    }
    const loggedInDetails = jwt_decode(
      getFromLocalStorage("vendor", "login").accessToken
    );
    return loggedInDetails;
  } catch (e) {
    console.log(e, "error is");
  }
};

export const getScmDecodedTokenData = () => {
  try {
    if (!getFromLocalStorage("scm", "login")) {
      return {};
    }
    const loggedInDetails = jwt_decode(
      getFromLocalStorage("scm", "login").accessToken
    );
    return loggedInDetails;
  } catch (e) {
    console.log(e, "error is");
  }
};

export const setInSessionStorage = (key, val) => {
  sessionStorage.setItem(key, val);
};

export const getFromSessionStorage = (key) => {
  return sessionStorage.getItem(key);
};

export const getFormBody = () => {
  const { refreshToken, accessToken } = getUserLoggedInDetails();
  let details = {
    client_id: keycloakConfig.clientId,
    Authorization: accessToken,
    refresh_token: refreshToken,
  };
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  return formBody;
};

export const removeAllDataFromStorage = () => {
  removeFromLocalStorage("lco", "login");
  removeFromLocalStorage("lco", "header");
  removeFromLocalStorage("team", "login");
  removeFromLocalStorage("team", "header");
  removeFromLocalStorage("LCO", "ID");
  removeFromLocalStorage("LCO", "_Cart_Products");
  removeFromLocalStorage("LCO", "_Existing_Cart");
  removeFromLocalStorage("lco", "ToolTip");
  removeFromLocalStorage("vendor", "login");
  removeFromLocalStorage("scm", "login");
  removeFromLocalStorage("lco", "_addendum_notify");
};

export const isAuthenticated = () => {
  const userAuthDetail = getUserLoggedInDetails();
  return userAuthDetail && userAuthDetail.accessToken;
};

export const isPartnerAuthenticated = () => {
  const userAuthDetail = getPartnerLoggedInDetails();
  return userAuthDetail && userAuthDetail.accessToken;
};

export const isScmAuthenticated = () => {
  const userAuthDetail = getScmLoggedInDetails();
  return userAuthDetail && userAuthDetail.accessToken;
};

export const isPartner = () => {
  if (window.location.pathname.includes("partner")) {
    return true;
  }
  return false;
};

export const isVendor = () => {
  if (window.location.pathname.includes("vendor")) {
    return true;
  }
  return false;
};

export const isMarketPlace = () => {
  if (window.location.pathname.includes("scm")) {
    return true;
  }
  return false;
};

export const getUniqueMachineId = () => {
  var fingerprint = new Fingerprint(
    { canvas: true },
    { screen_resolution: true },
    { ie_activex: true }
  ).get();
  return fingerprint.toString();
};

export const getEncryptedRsaString = (message, publicRsaKey) => {
  if (!message || !publicRsaKey) return message;

  var pki = forge.pki;
  var pkey = publicRsaKey;
  var pkeyDer = forge.util.decode64(pkey);

  var pkeyAsn1 = forge.asn1.fromDer(pkeyDer);
  var publicKey = pki.publicKeyFromAsn1(pkeyAsn1);
  // eslint-disable-next-line no-undef
  var encryptedMsg = publicKey.encrypt(message, "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: {
      md: forge.md.sha1.create(),
    },
  });
  return forge.util.encode64(encryptedMsg);
};

export const getEncryptionDetails = () => {
  const encryptionDetails = getFromLocalStorage(
    isPartner() ? "team" : "lco",
    "secure"
  );
  return encryptionDetails;
};

export const getEncryptedMessage = (message) => {
  const keyDetails = getEncryptionDetails();
  const pubKey = keyDetails && keyDetails.publicKey;
  const encryptedMsg = getEncryptedRsaString(message, pubKey);
  return encryptedMsg;
};

export const getFirstAndLastName = (username) => {
  let firstName, lastName;
  username = username.trim();
  let nameSplitArray = username.split(" ").filter((el) => el);

  if (notEmptyArray(nameSplitArray)) {
    firstName = nameSplitArray[0];
    nameSplitArray.splice(0, 1);
    lastName = nameSplitArray.join(" ");
  }

  return { firstName, lastName };
};

/**
 * This function fetches public rsa key, used in encryption of data and store it in local storage
 */
export const fetchPublicRsaKey = async () => {
  const resp = await fetchPublicRsaKeyAPI();
  const pkey = resp && resp.key;
  const encryptionData = { publicKey: pkey };
  setInLocalStorage("lco", "secure", encryptionData);
};

/**
 * fetch public key only when it's not present in local storage
 */
export const fetchEncryptionData = async () => {
  const encyptionDetails = getEncryptionDetails();
  if (!encyptionDetails) {
    await fetchPublicRsaKey();
  }
};

/**
 * return if url is http url
 */
export const isValidHttpUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

/**
 *
 * @param {*} time
 * takes the date and convert into the format specified
 */
export const formatDate = (time, format) => {
  const moment = extendMoment(originalMoment);
  return moment(time).format(format || "DD-MM-YYYY");
};

/**
 * This function returns the value of any numerical figure in Indian System
 */

export const getIndianCurrencySystem = (amount) => {
  return `₹${amount.toLocaleString("en-IN")}`;
};

/**
 * This function returns any type of date in string format to local date string format
 */

export const getLocalDate = (date) => {
  return new Date(date).toLocaleDateString();
};

/**
 * This function downloads the resources
 */

export const downloadResource = (url, fileName) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "file";
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBlobDoc = (fileData, fileName) => {
  const link = document.createElement("a");
  const url = window.URL.createObjectURL(new Blob([fileData]));
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const convertDecimalToReadableText = (number, decPlaces) => {
  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces);
  var abbrev = ["k", "m", "b", "t"];
  for (var i = abbrev.length - 1; i >= 0; i--) {
    var size = Math.pow(10, (i + 1) * 3);

    if (size <= number) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      number = Math.round((number * decPlaces) / size) / decPlaces;

      // Handle special case where we round up to the next abbreviation
      if (number === 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }

      number += abbrev[i];
      break;
    }
  }

  return number;
};

export const getMaxMinForGraph = (data, config) => {
  let minIncomeAmount = 0;
  let maxIncomeAmount = 0;
  let minInvestmentAmount = 0;
  let maxInvestmentAmount = 0;
  data.map((val) => {
    if (parseFloat(val.incomeAmount) > maxIncomeAmount) {
      maxIncomeAmount = parseInt(val.incomeAmount);
    }
    if (parseFloat(val.incomeAmount) < minIncomeAmount) {
      minIncomeAmount = parseInt(val.incomeAmount);
    }
    if (parseFloat(val.investmentAmount) > maxInvestmentAmount) {
      maxInvestmentAmount = parseInt(val.investmentAmount);
    }
    if (parseFloat(val.investmentAmount) < minInvestmentAmount) {
      minInvestmentAmount = parseInt(val.investmentAmount);
    }

    return null;
  });
  const maxIncome = Math.round(maxIncomeAmount / 1000) * 1000;
  const MaxIncomeRange =
    (maxIncome &&
      maxIncome.toString().split("").length &&
      ++maxIncome.toString().split("")[0]) *
    (maxIncome && Math.pow(10, maxIncome.toString().length - 1));

  const maxInvestment = Math.round(maxInvestmentAmount / 1000) * 1000;
  const MaxInvestmentRange =
    (maxInvestment &&
      maxInvestment.toString().split("").length &&
      ++maxInvestment.toString().split("")[0]) *
    (maxInvestment && Math.pow(10, maxInvestment.toString().length - 1));

  return {
    incomeAmount: {
      min: Math.round(minIncomeAmount / 1000) * 1000,
      max:
        config && config.type === "breakeven"
          ? Math.max(MaxInvestmentRange, MaxIncomeRange)
          : MaxIncomeRange,
    },
    investmentAmount: {
      min: Math.round(minInvestmentAmount / 1000) * 1000,
      max:
        config && config.type === "breakeven"
          ? Math.max(MaxInvestmentRange, MaxIncomeRange)
          : MaxInvestmentRange,
    },
  };
};
export const isAuthenticatedEmployee = () => {
  return false;
};

export const isAuthenticatedPartner = () => {
  return true;
};

export const flatten = (arr) => {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(
      Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten
    );
  }, []);
};

export const getDropdownOption = (options) => {
  const data =
    options &&
    options.length &&
    options.filter((item) => item !== null && item !== undefined);
  return data.map((option) => option && { label: option, value: option });
};

export const getMappedData = (headers, data) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map((item) => {
    const newItem = {};
    for (let i of headers) {
      if (i["key"]) newItem[i["key"]] = item[i["key"]];
    }
    return newItem;
  });
};

export const getFieldsFromFormData = (data) => {
  return data.map((val) => val.fields);
};

export const downloadBase64 = (base64, fileName) => {
  // Base64 Download
  let fileURL = "";
  if (fileName && fileName.includes("pdf")) {
    fileURL = `data:application/pdf;base64,`;
  } else if (fileName && fileName.includes("csv")) {
    fileURL = `data:text/csv;base64,`;
  } else if (fileName && fileName.includes("xlsx")) {
    fileURL =
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
  } else {
    fileURL = `${`data:image/${fileName.split(".")[1]};base64,`}`;
  }
  fileURL += base64;
  downloadResource(fileURL, fileName);
};

export const downloadCSV = (json, fileName) => {
  let csvContent = "data:text/csv;charset=utf-8,";

  json.forEach(function (rowArray, index) {
    let keys = Object.keys(rowArray);
    let values = Object.values(rowArray);
    let row = null;
    if (index === 0) {
      row = keys.join(",");
      csvContent += row + "\r\n";
      row = null;
    }
    row = values.join(",");
    csvContent += row + "\r\n";
  });
  downloadResource(csvContent, fileName);
};

export const removeUnderscore = (data) => {
  return data && data.length && data.map((val) => val.replace("_", " "));
};

export const getArrayData = (data) => {
  if (Array.isArray(data)) {
    return data;
  } else if (data) {
    return [{ ...data }];
  }
};

export const decodeData = (data) => {
  try {
    const _data = decodeURIComponent(atob(data));
    return JSON.parse(_data);
  } catch (error) {
    return null;
  }
};

export const throttleFunction = (func, delay) => {
  let prev = 0;
  return (...args) => {
    let now = new Date().getTime();
    if (now - prev > delay) {
      prev = now;
      return func(...args);
    }
  };
};

export const getYearsArray = (startYear) => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (var i = startYear; i <= currentYear; i++) {
    years.push(i);
  }
  return years;
};

export const getYearsRangeArray = (startYear) => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (var i = startYear; i <= currentYear; i++) {
    years.push(`${i}-${i + 1}`);
  }
  return years;
};

export const processAPIDataInactive = (info) => {
  if (info && Object.keys(info).length) {
    const updatedData = Object.keys(info).map((key) => {
      let obj = {};
      let count = 0;
      if (key) {
        const date = key.split("_")[0];
        const status = key.split("_")[1];

        info[key] &&
          info[key].length &&
          info[key].map((res) => {
            count += res.count;

            return null;
          });

        obj.status = status;
        obj.day = new Date(date).getDate();
        obj.month = new Date(date).getMonth();
        obj.year = new Date(date).getFullYear();
        obj.count = count;
        obj.details = info[key];

        return obj;
      }

      return null;
    });
    return updatedData;
  }
};

export const numberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const sortByMonth = (arr) => {
  var months = [
    "DECEMBER",
    "NOVEMBER",
    "OCTOBER",
    "SEPTEMBER",
    "AUGUST",
    "JULY",
    "JUNE",
    "MAY",
    "APRIL",
    "MARCH",
    "FEBRUARY",
    "JANUARY",
  ];
  arr.sort(function (a, b) {
    return months.indexOf(a.month) - months.indexOf(b.month);
  });

  return arr;
};

export const multiIndex = (obj, is) => {
  return is && is.length
    ? multiIndex(obj && is[0] && obj[is[0]], is.slice(1))
    : obj;
};

export const pathIndex = (obj, is) => {
  return multiIndex(obj, is.split("."));
};

export const getFormattedDropdownData = (data) => {
  return data.map((item) => ({ label: item, value: item }));
};

export const parseStringToHtml = (htmlString) => {
  return parse(htmlString);
};

export const getPartnershipId = () => {
  let selectedPartnership = JSON.parse(
    getFromSessionStorage("selectedPartnership")
  );
  return selectedPartnership && selectedPartnership.id;
};

export const getNestedDataFromKey = (key, obj) => {
  let data = { ...obj };
  const split_keys = key.split(".");
  for (let i in split_keys) {
    if (data[split_keys[i]]) {
      data = data[split_keys[i]];
    } else return "";
  }
  if (isNaN(data) && !isNaN(new Date(data).getMonth())) {
    return moment(new Date(data)).format("DD-MM-YYYY");
  } else if (typeof data === "object") {
    return "";
  } else return data;
};

export const getLoggedInUser = () => {
  if (isPartner()) {
    return getPartnerLoggedInDetails();
  } else if (isVendor()) {
    return getVendorLoggedInDetails();
  } else if (isMarketPlace()) {
    return getScmLoggedInDetails();
  }
  return getUserLoggedInDetails();
};

export const getTokenData = () => {
  if (isPartner() || isVendor()) {
    return getPartnerDecodedTokenData();
  } else if (isMarketPlace()) {
    return getScmDecodedTokenData();
  }
  return getDecodedTokenData();
};
export const getAppId = () => {
  if (isPartner()) {
    return "TEAM";
  }
  if (isVendor()) {
    return "INSURANCE_VENDOR";
  } else if (isMarketPlace()) {
    return "MARKETPLACE";
  }
  return "LCO";
};

export const getUserId = (tokenDecoded) => {
  if (isPartner() || isVendor()) {
    return tokenDecoded.preferred_username;
  }
  return tokenDecoded.sub;
};

export const getUserUUID = (tokenDecoded) => {
  if (isPartner() || isVendor()) {
    return tokenDecoded.preferred_username;
  }
  return tokenDecoded.sub;
};

export const isSubUserLoggedIn = () => {
  let tokenDecoded = getTokenData();
  return tokenDecoded.realm_access?.roles?.includes("SUBUSER");
};
